export const checkSpelling = async (text) => {
    const url = 'https://speller.yandex.net/services/spellservice.json/checkText';

    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `text=${encodeURIComponent(text)}&lang=ru,en&options=512`
    });

    if (!response.ok) throw new Error(`Ошибка HTTP! статус: ${response.status}`);

    return await response.json();
};